import { render, staticRenderFns } from "./webDomain.vue?vue&type=template&id=2aa6ad20"
import script from "./webDomain.vue?vue&type=script&lang=js"
export * from "./webDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports